import React, { useState } from 'react';
import "./App.css";
import { useNavigate } from 'react-router-dom';

import logoECJ from "./img/ecj-logo.svg";

function App() {
  const [userId, setUserId] = useState('');

  const navigate = useNavigate();

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000';

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${BACKEND_URL}/responses`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: userId,
        })
      });

      if (!res.ok) {
        const error = await res.text();
        alert("Error al enviar: " + error);
        return;
      }

      navigate("/gracias");
    } catch (error) {
      alert("Error de red o de servidor: " + error.message);
    }
  };


  return (
    <div className='container'>
      <img
        className='logoECJ'
        src={logoECJ}
        alt="EconoJournal"
      />
      <h2>Acreditación: Supplier Day</h2>
      <h4>Completá con tu código de registro para confirmar tu participación.</h4>
      <form onSubmit={handleSubmit}>
          <label>Código de registro: <b>*</b></label>
          <input type="text" value={userId} onChange={(e) => setUserId(e.target.value)} required title="Debes completar con tu código de registro" />
          <button type="submit">Confirmar asistencia</button>
      </form>
    </div>
  );
}

export default App;